var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterLogoWhite = function SvgTwitterLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "204px",
    viewBox: "0 0 250 204",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter_Logo_White",
    transform: "translate(-75.000000, -98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter_Logo_Blue"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62,301.59 C247.96,301.59 299.56,223.43 299.56,155.65 C299.56,153.43 299.56,151.22 299.41,149.02 C309.448314,141.759109 318.113555,132.768794 325,122.47 C315.638791,126.618018 305.708293,129.338286 295.54,130.54 C306.24744,124.129821 314.261235,114.04772 318.09,102.17 C308.021575,108.144553 297.006461,112.35512 285.52,114.62 C269.620828,97.7139428 244.357194,93.5761258 223.895493,104.526799 C203.433792,115.477473 192.86275,138.793257 198.11,161.4 C156.868957,159.332495 118.444758,139.853233 92.4,107.81 C78.7862276,131.246447 85.7398788,161.228595 108.28,176.28 C100.117412,176.038075 92.1327937,173.836132 85,169.86 C85,170.07 85,170.29 85,170.51 C85.0066813,194.92593 102.217515,215.955352 126.15,220.79 C118.598696,222.8494 110.675806,223.150443 102.99,221.67 C109.709479,242.564228 128.965746,256.877839 150.91,257.29 C132.74735,271.564319 110.310595,279.313277 87.21,279.29 C83.1290357,279.282165 79.0520407,279.035075 75,278.55 C98.4563595,293.602766 125.749134,301.587169 153.62,301.55",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter_logo_white.18dee189.svg";
export { ForwardRef as ReactComponent };